// extracted by mini-css-extract-plugin
export var linkInner = "IconLink-module--link-inner--27JH4";
export var ctaAlignLeft = "IconLink-module--ctaAlign-left--1dDiC";
export var ctaAlignRight = "IconLink-module--ctaAlign-right--21eR9";